


































import { IJobMatchProfile, IOccupation } from '@app/componentlib/common/types/JobMatchTypes'
import { IFIlteredJobGoal, IWizardStepJobGoal } from '@app/componentlib/common/types/WizardTypes'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'
import Vue from 'vue'
import Component from 'vue-class-component'
import OccupationListItem from '@app/componentlib/src/views/components/OccupationListItem.vue'

@Component<WizardStepJobMatchJobGoal>({
  props: {
    wizardstep: Object
  },
  components: {
    OccupationListItem
  }
})

export default class WizardStepJobMatchJobGoal extends Vue {
  /**
   * Props variables
   */
  wizardstep: IWizardStepJobGoal | undefined

  /**
   * Component state variables
   */
  sortedJobGoals: IFIlteredJobGoal[] = []

  /**
   * Lifecycle
   */
  async mounted() {
    await JobMatchModule.getJobGoals()
  }

  /**
   * Getters
   */
  get jobmatchProfile (): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  get selectedOccupations (): IOccupation[] {
    return JobMatchOccupationModule.selectedOccupations
  }

  get jobGoals (): any {
    return JobMatchModule.jobGoals
  }

  get noJobGoals (): boolean {
    let exists = true

    for (let item in this.jobGoals) {
      if(this.jobGoals[item].goals.length > 0)
        exists = false
    }

    return exists
  }

  /**
   * Methods
   */
   buttonClicked() {
    this.$emit('buttonClicked')
  }
}
